
<ng-container>
  <div class="content-container-directtion">
    @if (showSpinner) {
      <div class="loading">
        <fa-icon [icon]="faCircleNotch" [animation]="'spin'"></fa-icon>
      </div>
    }

    @if (initiated == true) {
      <h1>DIRECTIONS</h1>
    }

    <!--Custom Collapsible Headers-->
    @if (initiated == true) {
      <div class="row">
        @if (initiated == true) {
          <div class="col-sm-3" style="height:100vh;">
            <ul class="destinations collapsible">
              <!-- Hearing Rooms -->
              <li id="hearingRooms" class="hearingRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableHearing" data-target="#collapsableHearing" type="button" (click)="onExpand($event)">{{hearingRooms.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableHearing" [ngClass]="{'show': currHeader == 'Hearing Rooms'}">
                    @for (hearingRoom of hearingRooms.items; track hearingRoom) {
                      <div [ngClass]="{'active': currHeader == 'Hearing Rooms' && roomSelected.title == hearingRoom.title}" style="display:block;">
                        <a id="hearingItem" class=" collection-item waves-effect hearingItem" (click)="onShowDirection(hearingRoom, null, true)"><span class="locationName">{{hearingRoom.title}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- Senators -->
              <li id="senRooms" class="senRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableSen" data-target="#collapsableSen" type="button" (click)="onExpand($event)">{{senators.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableSen" [ngClass]="{'show': currHeader == 'Senators'}">
                    @for (senRoom of senators.items; track senRoom) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'Senators' && roomSelected.title == senRoom.title}">
                        <a id="senItem" class=" collection-item waves-effect senItem" (click)="onShowDirection(senRoom, null, true)"><span class="locationName">{{senRoom.title}}</span> <span class="secondary-content">{{senRoom.target}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- Represenatives -->
              <li id="repRooms" class="repRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableRep" data-target="#collapsableRep" type="button" (click)="onExpand($event)">{{representatives.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableRep" [ngClass]="{'show': currHeader == 'Representatives'}">
                    @for (repRoom of representatives.items; track repRoom) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'Representatives' && roomSelected.title == repRoom.title}">
                        <a id="repItem" class=" collection-item waves-effect repItem" (click)="onShowDirection(repRoom, null, true)"><span class="locationName">{{repRoom.title}}</span> <span class="secondary-content">{{repRoom.target}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- Senate Committees -->
              <li id="senateCommitteeRooms" class="senateCommitteeRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableSenComm" data-target="#collapsableSenComm" type="button" (click)="onExpand($event)">{{senComm.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableSenComm" [ngClass]="{'show': currHeader == 'Senate Committees'}">
                    @for (senCommRoom of senComm.items; track senCommRoom) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'Senate Committees' && roomSelected.title == senCommRoom.title}">
                        <a id="senCommItem" class=" collection-item waves-effect senCommItem" (click)="onShowDirection(senCommRoom, null, true)"><span class="locationName">{{senCommRoom.title}}</span><span class="secondary-content">{{senCommRoom.target}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- House Committees -->
              <li id="houseCommitteeRooms" class="houseCommitteeRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableHouseComm" data-target="#collapsableHouseComm" type="button" (click)="onExpand($event)">{{houseComm.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableHouseComm" [ngClass]="{'show': currHeader == 'House Committees'}">
                    @for (houseCommRoom of houseComm.items; track houseCommRoom) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'House Committees' && roomSelected.title == houseCommRoom.title}">
                        <a id="houseCommItem" class=" collection-item waves-effect houseCommItem" (click)="onShowDirection(houseCommRoom, null, true)"><span class="locationName">{{houseCommRoom.title}}</span><span class="secondary-content">{{houseCommRoom.target}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- Joint Committees (Senate Rooms) -->
              <li id="jointCommitteeSenateRooms" class="jointCommitteeSenateRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableJointCommSenate" data-target="#collapsableJointCommSenate" type="button" (click)="onExpand($event)">{{jointCommSenate.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableJointCommSenate" [ngClass]="{'show': currHeader == 'Joint Committees (Senate Room)'}">
                    @for (jointCommRoomSenate of jointCommSenate.items; track jointCommRoomSenate) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'Joint Committees (Senate Room)' && roomSelected.title == jointCommRoomSenate.title}">
                        <a id="jointCommSenateItem" class=" collection-item waves-effect jointCommSenateItem" (click)="onShowDirection(jointCommRoomSenate, null, true)"><span class="locationName">{{jointCommRoomSenate.title}}</span><span class="secondary-content">{{jointCommRoomSenate.target}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- Joint Committees (House Rooms) -->
              <li id="jointCommitteeHouseRooms" class="jointCommitteeHouseRooms">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsableJointCommHouse" data-target="#collapsableJointCommHouse" type="button" (click)="onExpand($event)">{{jointCommHouse.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection collapse" id="collapsableJointCommHouse" [ngClass]="{'show': currHeader == 'Joint Committees (House Room)'}">
                    @for (jointCommRoomHouse of jointCommHouse.items; track jointCommRoomHouse) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'Joint Committees (House Room)' && roomSelected.title == jointCommRoomHouse.title}">
                        <a id="jointCommHouseItem" class=" collection-item waves-effect jointCommHouseItem" (click)="onShowDirection(jointCommRoomHouse, null, true)"><span class="locationName">{{jointCommRoomHouse.title}}</span><span class="secondary-content">{{jointCommRoomHouse.target}}</span></a>
                      </div>
                    }
                  </div>
                </div>
              </li>
              <!-- Point of Interests -->
              <li id="pointOfInterests" class="pointOfInterests">
                <h3 class="collapsible-header  waves-effect" aria-expanded="false" data-toggle="collapse" aria-controls="collapsablePintsOI" data-target="#collapsablePintsOI" type="button" (click)="onExpand($event)">{{pointsOI.name}}</h3>
                <div class="collapsible-body" style="display:block;">
                  <div class="collection  collapse" id="collapsablePintsOI" [ngClass]="{'show': currHeader == 'Points of Interest'}">
                    @for (pointsOIRoom of pointsOI.items; track pointsOIRoom) {
                      <div style="display:block;" [ngClass]="{'active': currHeader == 'Points of Interest' && roomSelected.title == pointsOIRoom.title}">
                        <a id="pointsOIItem" class=" collection-item waves-effect pointsOIItem" (click)="onShowDirection(pointsOIRoom, null, true)"><span class="locationName">{{pointsOIRoom.title}}</span>@if (pointsOIRoom.icon != null && pointsOIRoom.icon === 'fa-wheelchair') {
                        <span class="secondary-content"><fa-icon [icon]="faWheelchair"></fa-icon></span>
                      }</a>
                    </div>
                  }
                </div>
              </div>
            </li>
          </ul>
          <!-- Wheechair Accessible -->
          @if (!wheelchairAccessible) {
            <div (click)="onCheckBox()" class="wheelChair">
              <input id="checkBox" type="checkbox" style="margin-left: 1%;" />
              <label class="wheelChairCheckBox"> Wheelchair Accessible</label>
            </div>
          }
          @if (wheelchairAccessible) {
            <div (click)="onCheckBox()" class="wheelChair">
              @if (wheelchairAccessible) {
                <label class="wheelChairCheckBox">
                  @if (wheelchairAccessible) {
                    <span>&#10003;</span>
                  }
                  Wheelchair Accessible
                </label>
              }
            </div>
          }
        </div>
      }
      <!--Directions details-->
      <div class="col-sm-9">
        <div class="directions-wrapper">
          @if (showSpinnerDetail) {
            <div class="loading">
              <fa-icon [icon]="faCircleNotch" [animation]="'spin'"></fa-icon>
            </div>
          }
          @if (room == undefined) {
            <div>
              <div class="directions-background no-scroll " style="height:75vh;">
                <div class="centered-wrapper">
                  <div class="loadingOverlay">
                    <div>
                      <fa-icon [icon]="faLongArrowAltLeft" class=" fa"></fa-icon>
                      <span> Select a destination</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (showNoDirection == true) {
            <div>
              <div class="directions-background no-scroll " style="height:75vh;">
                <div class="centered-wrapper">
                  <div class="loadingOverlay">
                    <div>
                      <fa-icon [icon]="faExclamationTriangle" class=" fa"></fa-icon>
                      <span> Could Not Generate Directions To This Location Please Try Another Destination</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (room != null && room != 'directions' && showNoDirection == false && !showSpinnerDetail) {
            <div>
              <div fill-container class="directions-background no-scroll " style="height: 70vh; background-image: url({{img}})">
                <div class="directions-container" style="height:70vh;">
                  <div class="row">
                    @if (directions.endName) {
                      <h2 class="directionTarget">Directions {{directions.endName}}</h2>
                    }
                    @if (onSelected && directions.navigation[0]) {
                      <div class="directionBucket">
                        @if (directions.navigation[0]) {
                          <button id="firstFloorButtonb" class="btn-direction2 active" (click)="onChangeRoom($event)"> {{directions.navigation[0].floorName}}</button>
                        }
                        @for (firstSetDirection of directions.navigation[0].route; track firstSetDirection; let i = $index) {
                          <div>
                            <span class="bucketText">{{i + 1}}. {{firstSetDirection.directions}}</span>
                          </div>
                        }
                      </div>
                    }
                    @if (onSelected && directions.navigation[1]) {
                      <div class="directionBucket">
                        @if (directions.navigation[1]) {
                          <button id="secondFloorButtonb" class="btn-direction2" (click)="onChangeRoom($event)"> {{directions.navigation[1].floorName}}</button>
                        }
                        @for (secondSetDirection of directions.navigation[1].route; track secondSetDirection; let i = $index) {
                          <div>
                            <span class="bucketText">{{i + 1}}. {{secondSetDirection.directions}}</span>
                          </div>
                        }
                      </div>
                    }
                    @if (onSelected && directions.navigation[2]) {
                      <div class="directionBucket">
                        @if (directions.navigation[2]) {
                          <button id="thirdFloorButtonb" class="btn-direction2" (click)="onChangeRoom($event)"> {{directions.navigation[2].floorName}}</button>
                        }
                        @for (thirdSetDirection of directions.navigation[1].route; track thirdSetDirection; let i = $index) {
                          <div>
                            <span class="bucketText">{{i + 1}}. {{thirdSetDirection.directions}}</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
</ng-container>
